export function getMinMaxDateForFilter(option: number) {
  var dateEnd = new Date(3000, 0, 1);
  //dateToday = addMonths(dateToday, 1); // to have 1 based month as default is 0 based
  // dateToday = addYears(dateToday, 1); // Requirement is to have 1+ year

  var minDate: Date = new Date();
  switch (option) {
    case 0: //6 months
      minDate = addMonths(new Date(), -6); // six months before now.
      console.log("6 months from now");
      break;
    case 1: //12 months
      minDate = addMonths(new Date(), -12); // 12 months before now
      console.log("12 months from now");
      break;
    case 2:
      minDate = addMonths(new Date(), -60); // sixty months before now
      console.log("5 years from now.");
      break;
    case 99:
      minDate = new Date(1500, 0, 1);
      console.log("All years.");
      break;
    case 100:
      console.log("Custom range.");
      break;
    default:
      console.log("default to todays");
    // console.log(`Sorry, we are out of ${expr}.`);
  }

  var mindate = formatDateForQueryParam(minDate);
  var maxdate = formatDateForQueryParam(dateEnd);

  console.log("from getMinMaxDateForFilter min date is:" + mindate);
  console.log("from getMinMaxDateForFilter max date is:" + maxdate);

  return { mindate: mindate, maxdate: maxdate };
}

//"yyyy/mm/dd"
export function formatDateForQueryParam(date: Date) {
  if (date === null || date === undefined) return "";

  const [month, day, year] = [
    date.getMonth(), //addMonths(date, 1).getMonth(), // to have 1 based month as default is 0 based
    date.getDate(),
    date.getFullYear(),
  ];

  return year + "/" + (month + 1) + "/" + day; // to have 1 based month index
}

export function addMonths(date: Date, months: number) {
  date.setMonth(date.getMonth() + months);
  return date;
}

export function addYears(date: Date, years: number) {
  date.setFullYear(date.getFullYear() + years);
  return date;
}

export function getCurrentDateTime() {
  let current = new Date();
  let cDate =
    current.getFullYear() +
    "-" +
    (current.getMonth() + 1) +
    "-" +
    current.getDate();
  let cTime =
    current.getHours() +
    ":" +
    current.getMinutes() +
    ":" +
    current.getSeconds();
  let dateTime = cDate + " " + cTime;
  return dateTime;
}
